module.exports = __webpack_public_path__ + "static/img/img_fuwu_002.ccc18c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_fuwu_002.png
// module id = KcGU
// module chunks = 19